/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Delivery API
 * This API manages the projects and docuements that are stored in the Ameta Document Delivery. The API used oAuth2 flow for authorization.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GeoJSONLocation,
    GeoJSONLocationFromJSON,
    GeoJSONLocationFromJSONTyped,
    GeoJSONLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyProjectRelation
 */
export interface CompanyProjectRelation {
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    sort: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    accessType: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    projectName: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    projectNumber: string;
    /**
     * 
     * @type {GeoJSONLocation}
     * @memberof CompanyProjectRelation
     */
    projectLocation?: GeoJSONLocation;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    projectDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    customerProjectNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    projectOwnerName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyProjectRelation
     */
    projectOwnerId?: string;
}

export function CompanyProjectRelationFromJSON(json: any): CompanyProjectRelation {
    return CompanyProjectRelationFromJSONTyped(json, false);
}

export function CompanyProjectRelationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyProjectRelation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sort': json['sort'],
        'companyName': json['companyName'],
        'accessType': json['accessType'],
        'projectName': json['projectName'],
        'projectNumber': json['projectNumber'],
        'projectLocation': !exists(json, 'projectLocation') ? undefined : GeoJSONLocationFromJSON(json['projectLocation']),
        'projectDescription': !exists(json, 'projectDescription') ? undefined : json['projectDescription'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'customerProjectNumber': !exists(json, 'customerProjectNumber') ? undefined : json['customerProjectNumber'],
        'projectOwnerName': !exists(json, 'projectOwnerName') ? undefined : json['projectOwnerName'],
        'projectOwnerId': !exists(json, 'projectOwnerId') ? undefined : json['projectOwnerId'],
    };
}

export function CompanyProjectRelationToJSON(value?: CompanyProjectRelation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sort': value.sort,
        'companyName': value.companyName,
        'accessType': value.accessType,
        'projectName': value.projectName,
        'projectNumber': value.projectNumber,
        'projectLocation': GeoJSONLocationToJSON(value.projectLocation),
        'projectDescription': value.projectDescription,
        'startDate': value.startDate,
        'endDate': value.endDate,
        'customerProjectNumber': value.customerProjectNumber,
        'projectOwnerName': value.projectOwnerName,
        'projectOwnerId': value.projectOwnerId,
    };
}


